import Link from 'next/link'

function BlogTags({ tags }) {
    return (
        <div className="mt-6 px-4">
            <div className="flex flex-wrap gap-2">
                {tags.map((tag) => (
                    <Link key={tag.id} href={`/blog/tag/${tag.slug}`}>
                        <a
                            className="text-sm text-gray-600 hover:text-gray-900 cursor-pointer"
                            style={{ fontSize: `${12 + tag.count / 2}px` }}>
                            {tag.name}
                        </a>
                    </Link>
                ))}
            </div>
        </div>
    )
}

export default BlogTags
